import React, { useState } from "react";

// IMPORTAR FUNÇÕES
import { lerAlunos } from "../../../firebase/mensagens";
import { enviarMensagemDoProfessor, enviarMensagemEmMassa } from "../../../firebase/mensagens";

const FormEnviarMensagemParaAlunos = () => {

    // DADOS
    const storedLogado = localStorage.getItem('logado');
    const storedUsuario = localStorage.getItem('usuario');  
    const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
    const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);
    
    // INPUTS    
    const [formMensagemProfessorSerie, setFormMensagemProfessorSerie] = useState('');
    const [formMensagemProfessorAluno, setFormMensagemProfessorAluno] = useState([]);
    const [formMensagemProfessorMensagem, setFormMensagemProfessorMensagem] = useState('');
    
    // SERIES
    const listaSeries = localStorage.getItem('series');
    const series = listaSeries ? JSON.parse(listaSeries) : [];
    const [serie, setSerie] = useState([]);

    // LER ALUNOS
    const [alunos, setAlunos] = useState([]);
    const handleLerAlunos = async (serie) => {
        await setSerie(serie);
        const resposta = await lerAlunos(serie);
        if (resposta.length === 0) {
            await setAlunos(false);  
        } else {
            await setAlunos(resposta);
        }
    }

    
    const handleFormMensagemProfessorAluno = async (event, aluno) => {
        const isChecked = event.target.checked;
    
        // Se o checkbox foi marcado, adiciona o aluno à lista de alunos selecionados
        // Se o checkbox foi desmarcado, remove o aluno da lista de alunos selecionados
        if (isChecked) {
          await setFormMensagemProfessorAluno((prevAlunos) => [...prevAlunos, aluno]);
        } else {
          await setFormMensagemProfessorAluno((prevAlunos) =>
            prevAlunos.filter((a) => a.aluno !== aluno.aluno)
          );
        }
    };

    return (
        <div className='form-tecvit wd-100'>
            
            <h1 className="mt-10">Enviar comunicado para aluno</h1>

            <div className='flex'>
                <select onChange={(e) => {
                    handleLerAlunos(e.target.value);
                    setFormMensagemProfessorSerie(e.target.value);
                }}>
                    <option value=''>Selecione uma série</option>
                    {series.length > 0 ? (
                    series.map((serie) => (
                        <option value={serie}>
                            {serie}
                        </option>
                    ))
                    ) : (
                    <option value="">Nenhuma série disponível</option>
                    )}
                </select>
                <label>Série</label>
            </div>


            <div className="decoracao wd-100 mb-10">
                <p>Alunos</p>
            </div>

            <div className="flex lista-inputs">
    
                {alunos.length > 0 ? (
                    alunos.map((aluno) => (
                        <li className="input-radio">
                            <input
                                name="alunos"
                                value={JSON.stringify({
                                    aluno: aluno.aluno,
                                    responsavel: aluno.responsavel,
                                    onesignalId: aluno.onesignalId,
                                })}
                                type="checkbox"
                                onChange={(event) => handleFormMensagemProfessorAluno(event, aluno)}
                            />
                            <div className="column ml-15">
                                <p>Aluno: {aluno.aluno}</p>
                                <p>Responsável: {aluno.responsavel}</p>
                            </div>
                        </li>
                    ))
                ) : (
                    <h1 className="mg-auto wd-auto">Nenhum aluno disponível</h1>
                )}
            </div>

            <div className='flex'>
            <textarea onChange={(e) => setFormMensagemProfessorMensagem(e.target.value)} placeholder=' '></textarea>
            <label>Mensagem</label>
            </div>

            <div className='flex'>
                <button onClick={() => enviarMensagemDoProfessor(formMensagemProfessorSerie, formMensagemProfessorAluno, formMensagemProfessorMensagem, usuario)}>Enviar Mensagem</button>  
            </div>
            
        </div>
    );
}

const FormEnviarMensagemEmMassa = () => {

    // DADOS
    const storedLogado = localStorage.getItem('logado');
    const storedUsuario = localStorage.getItem('usuario');  
    const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
    const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);
    

    // INPUTS    
    const [formMensagemProfessorSerie, setFormMensagemProfessorSerie] = useState('');
    const [formMensagemProfessorAluno, setFormMensagemProfessorAluno] = useState([]);
    const [formMensagemProfessorMensagem, setFormMensagemProfessorMensagem] = useState('');
    
    // SERIES
    const listaSeries = localStorage.getItem('series');
    const series = listaSeries ? JSON.parse(listaSeries) : [];
    const [serie, setSerie] = useState([]);

    // LER ALUNOS
    const [alunos, setAlunos] = useState([]);
    const handleLerAlunos = async (serie) => {
        await setSerie(serie);
        const resposta = await lerAlunos(serie);
        if (resposta.length === 0) {
            await setAlunos(false);  
        } else {
            await setAlunos(resposta);
        }
    }

    
    const handleFormMensagemProfessorAluno = async (event, aluno) => {
        const isChecked = event.target.checked;
    
        // Se o checkbox foi marcado, adiciona o aluno à lista de alunos selecionados
        // Se o checkbox foi desmarcado, remove o aluno da lista de alunos selecionados
        if (isChecked) {
          await setFormMensagemProfessorAluno((prevAlunos) => [...prevAlunos, aluno]);
        } else {
          await setFormMensagemProfessorAluno((prevAlunos) =>
            prevAlunos.filter((a) => a.aluno !== aluno.aluno)
          );
        }
    };

    return (
        <div className='form-tecvit wd-100'>
            
            <div className='flex'>
                <select onChange={(e) => {
                    handleLerAlunos(e.target.value);
                    setFormMensagemProfessorSerie(e.target.value);
                }}>
                    <option value=''>Selecione uma série</option>
                    {series.length > 0 ? (
                    series.map((serie) => (
                        <option value={serie}>
                            {serie}
                        </option>
                    ))
                    ) : (
                    <option value="">Nenhuma série disponível</option>
                    )}
                </select>
                <label>Série</label>
            </div>


            <div className="decoracao wd-100 mb-10">
                <p>Alunos</p>
            </div>

            <div className="flex lista-inputs">
    
                {alunos.length > 0 ? (
                    alunos.map((aluno) => (
                        <li className="input-radio">
                            <input
                                name="alunos"
                                value={JSON.stringify({
                                    aluno: aluno.aluno,
                                    responsavel: aluno.responsavel,
                                    onesignalId: aluno.onesignalId,
                                })}
                                type="checkbox"
                                onChange={(event) => handleFormMensagemProfessorAluno(event, aluno)}
                            />
                            <div className="column ml-15">
                                <p>Aluno: {aluno.aluno}</p>
                                <p>Responsável: {aluno.responsavel}</p>
                            </div>
                        </li>
                    ))
                ) : (
                    <h1 className="mg-auto wd-auto">Nenhum aluno disponível</h1>
                )}
            </div>

            <div className='flex'>
                <textarea onChange={(e) => setFormMensagemProfessorMensagem(e.target.value)} placeholder=' '></textarea>
                <label>Mensagem</label>
            </div>

            <div className='flex'>
                <button onClick={() => enviarMensagemEmMassa('outros', formMensagemProfessorMensagem, formMensagemProfessorAluno)}>Enviar Mensagem</button>  
            </div>
            
        </div>
    );
}

export { FormEnviarMensagemParaAlunos, FormEnviarMensagemEmMassa };